import { SET_NAMED_PARTY_SORT_FIELD } from '../types';

const setAmicusSortField = sortField => {
  return {
    type: SET_NAMED_PARTY_SORT_FIELD,
    payload: {
      sortField,
    },
  };
};

export default setAmicusSortField;
